import "jquery-validation";
import "jquery-validation/dist/localization/messages_ru";
import 'jquery-mask-plugin';
import ScrollBooster from 'scrollbooster';
import initTooltips from './components/tooltips';
import {imageObserver} from "./observers/lazyLoading";
import updateCounters from "./common/updateCounters";

global.jquery = global.jQuery = global.$ = require('jquery');
window.App = {};

window.App.getBreakpoint = function () {
    return window.getComputedStyle(document.body, ':before').content.replace(/\"/g, '');
}

window.App.analytics = require('./common/analytics');

require('./components/copy-to-clipboard');
require('./components/header');
require('./components/cookie-notification');

$(function () {
    jQuery.validator.addMethod("phoneRU", function (phone_number, element) {
        phone_number = phone_number.replace(/\s+/g, "");
        return this.optional(element) || phone_number.length > 10 &&
            phone_number.match(/^((7|8)+([0-9])\d{9})$/);
    }, "Укажите допустимый номер телефона");

    $('input[type="tel"]').mask('0 000 000 00 00');

    require('./components/menu');
    require('./components/modal');
    require('./modals/choose-your-city');
    require('./modals/adding-to-cart');
    require('./modals/recovery-partner-password');
    require('./modals/receipt-notification');

    if (!$('body').data('authUser')) {
        require('./modals/login');
        require('./modals/registration');
        require('./modals/recovery-password-by-email');
    }

    $('[data-scrollbooster="true"]').each(function () {
        new ScrollBooster({
            viewport: $(this).find('.viewport')[0],
            content: $(this).find('.content')[0],
            scrollMode: 'transform',
            direction: 'horizontal',
            emulateScroll: true
        });
    });

    window.App.lazyImageLoading = function () {
        document.querySelectorAll('img[data-src]').forEach(img => imageObserver.observe(img));
    }

    window.App.lazyImageLoading();

    window.App.initTooltips = initTooltips;
    window.App.initTooltips();

    window.App.updateCounters = updateCounters;
});